import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { TypeaheadComponent, WishlistName } from '../../atoms/atoms.index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IUser } from '../../../domain/user.interface';
import { getAssetUrl } from '../../../utils/GetAssetUrl';
import { IGroupResume } from '../../../domain/group.interface';
import './ShareWishModalForm.component.scss';
import { EUserType } from '../../../domain/typeahead.interfaces';
import { EDefaultWishList, IWishlist } from '../../../domain/wish.interface';

enum EShareType {
  user = 'user',
  group = 'group',
  list = 'list',
}

type TShareType = EShareType.group | EShareType.user | EShareType.list;

export default function ShareWishModalFormComponent(props: any) {
  const {
    showModal,
    handleClose,
    options,
    groupListOptions,
    wishListOptions,
    addRef,
    handleInputChange,
    handleOnBlur,
    handleAddNewSelectedGroup,
    handleAddNewSelectedList,
    handleRemoveSelectedUser,
    handleRemoveSelectedGroup,
    handleRemoveSelectedList,
    submitSelected,
    selectedUserShare,
    selectedGroupShare,
    selectedListShare,
  } = props;

  const [shareType, setShareType] = useState<TShareType | undefined>();
  const [selectRef, setSelectRef] = useState<any>();

  function resetModal() {
    setShareType(undefined);
    handleClose();
  }

  return (
    <Modal
      className='share-wish-modal'
      show={showModal}
      onHide={() => resetModal()}
      size='xl'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id='organisms.share-wish-modal-form.main_title' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='form-field-container'>
          <div className='field-container'>
            <div className='radio-container'>
              <label htmlFor='opt1' className='radio'>
                <input
                  name='share-radio'
                  onChange={() => setShareType(EShareType.user)}
                  value={EShareType.user}
                  type='radio'
                  id='opt1'
                  className='hide'
                />
                <span className='label'></span>
                <FormattedMessage id='common.user' values={{ value: 1 }} />
              </label>
              <label htmlFor='opt2' className='radio'>
                <input
                  name='share-radio'
                  onChange={() => {
                    setShareType(EShareType.group);
                  }}
                  value={EShareType.group}
                  type='radio'
                  id='opt2'
                  className='hide'
                />
                <span className='label'></span>
                <FormattedMessage id='common.group' values={{ value: 1 }} />
              </label>
              <label htmlFor='opt3' className='radio'>
                <input
                  name='share-radio'
                  onChange={() => setShareType(EShareType.list)}
                  value={EShareType.list}
                  type='radio'
                  id='opt3'
                  className='hide'
                />
                <span className='label'></span>
                <FormattedMessage id='common.list' values={{ value: 1 }} />
              </label>
            </div>
          </div>
          <div>
            {shareType === EShareType.user && (
              <div className='field-container'>
                <FormattedMessage id='organisms.share-wish-modal-form.placeholder'>
                  {(txt: any) => (
                    <TypeaheadComponent
                      label={txt}
                      addRef={addRef}
                      handleInputChange={handleInputChange}
                      handleOnBlur={handleOnBlur}
                      options={options}
                    />
                  )}
                </FormattedMessage>
              </div>
            )}
          </div>
          <div>
            {shareType === EShareType.group && (
              <div className='field-container'>
                <FormattedMessage id='organisms.share-wish-modal-form.placeholder2'>
                  {(txt: any) => (
                    <div className='select-wrapper'>
                      <select
                        defaultValue={''}
                        className='field'
                        ref={(el: any) => setSelectRef(el)}
                        onChange={(e: any) => {
                          handleAddNewSelectedGroup(Number(e.target.value));
                          selectRef.value = '';
                        }}
                      >
                        <option value={''} disabled>
                          {txt}
                        </option>
                        {!!groupListOptions.length &&
                          groupListOptions.map((option: any) => (
                            <option value={option.id} key={option.id}>
                              {option.name}
                            </option>
                          ))}
                      </select>
                      <FontAwesomeIcon
                        icon='angle-down'
                        className='select-arrow'
                      />
                    </div>
                  )}
                </FormattedMessage>
              </div>
            )}
          </div>
          <div>
            {shareType === EShareType.list && (
              <div className='field-container'>
                <FormattedMessage id='organisms.share-wish-modal-form.placeholder3'>
                  {(txt: any) => (
                    <div className='select-wrapper'>
                      <select
                        defaultValue={''}
                        className='field'
                        ref={(el: any) => setSelectRef(el)}
                        onChange={(e: any) => {
                          handleAddNewSelectedList(Number(e.target.value));
                          selectRef.value = '';
                        }}
                      >
                        <option value={''} disabled>
                          {txt}
                        </option>
                        {!!wishListOptions.length &&
                          wishListOptions.map((option: IWishlist) =>
                            <WishlistName wishlist={option} />,
                          )}
                      </select>
                      <FontAwesomeIcon
                        icon='angle-down'
                        className='select-arrow'
                      />
                    </div>
                  )}
                </FormattedMessage>
              </div>
            )}
          </div>
          {!!selectedUserShare.length && (
            <div className='list'>
              {selectedUserShare.map((user: IUser) => {
                const {
                  id,
                  alias,
                  nickname,
                  userPhoto,
                  isContact,
                  isActive,
                } = user;
                return (
                  <div
                    key={id}
                    className={`minicard ${
                      isContact
                        ? isActive
                          ? `user-type-${EUserType.CONTACT}`
                          : `user-type-${EUserType.INACTIVE}`
                        : `user-type-${EUserType.USER}`
                    }`}
                  >
                    <div className='minicard-image'>
                      {userPhoto ? (
                        <div
                          style={{
                            backgroundImage: `url(${getAssetUrl.imagesStatic(
                              userPhoto,
                            )})`,
                          }}
                        />
                      ) : (
                        <div className='icon-container d-flex justify-container-center align-items-center'>
                          <FontAwesomeIcon icon='user' />
                        </div>
                      )}
                    </div>
                    <div className='minicard-info'>
                      <h6>{!!alias ? alias : nickname}</h6>
                      {isActive ? (
                        <p>{nickname}</p>
                      ) : (
                        <p>
                          ( <FormattedMessage id='common.inactive-contact' /> )
                        </p>
                      )}
                    </div>
                    <div className='minicard-buttons'>
                      <div
                        className='minicard-delete'
                        onClick={() => handleRemoveSelectedUser(id)}
                      >
                        <FontAwesomeIcon icon='trash' />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {!!selectedGroupShare.length && (
            <div className='list'>
              {selectedGroupShare.map((group: IGroupResume) => {
                const { id, name } = group;
                return (
                  <div key={id} className='minicard'>
                    <div className='minicard-image'>
                      <div
                        style={{
                          backgroundSize: '75%',
                          backgroundImage: `url(${getAssetUrl.icons(
                            'GRUPOS_AMARILLO.svg',
                          )})`,
                        }}
                      />
                    </div>
                    <div className='minicard-info'>
                      <h6>{name}</h6>
                      <p>
                        ({' '}
                        <FormattedMessage
                          id='common.group'
                          values={{ value: 1 }}
                        />{' '}
                        )
                      </p>
                    </div>
                    <div className='minicard-buttons'>
                      <div
                        className='minicard-delete'
                        onClick={() => handleRemoveSelectedGroup(id)}
                      >
                        <FontAwesomeIcon icon='trash' />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {!!selectedListShare.length && (
            <div className='list'>
              {selectedListShare.map((wishList: any) => {
                const { id, name, isDefault } = wishList;
                const nameToShow = isDefault && name === EDefaultWishList.MY_WISHES ? (
                  <FormattedMessage id='pages.wishlist_catalogue.default_list_1'></FormattedMessage>
                ) : isDefault && name === EDefaultWishList.RECOMMENDED ? (
                  <FormattedMessage id='pages.wishlist_catalogue.default_list_2'></FormattedMessage>
                ) : (
                  name
                );
                return (
                  <div key={id} className='minicard'>
                    <div className='minicard-image'>
                      <div
                        style={{
                          backgroundSize: '75%',
                          backgroundImage: `url(${getAssetUrl.icons(
                            'VARITA_AMARILLA.svg',
                          )})`,
                        }}
                      />
                    </div>
                    <div className='minicard-info'>
                      <h6>{nameToShow}</h6>
                      <p>
                        ({' '}
                        <FormattedMessage
                          id='common.list'
                          values={{ value: 1 }}
                        />{' '}
                        )
                      </p>
                    </div>
                    <div className='minicard-buttons'>
                      <div
                        className='minicard-delete'
                        onClick={() => handleRemoveSelectedList(id)}
                      >
                        <FontAwesomeIcon icon='trash' />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className='btn-lili form-button danger mb-3 cancel-btn'
          onClick={() => resetModal()}
        >
          <FormattedMessage id='common.cancel'></FormattedMessage>
        </button>
        <button
          onClick={() => {
            setShareType(undefined);
            submitSelected();
          }}
          className='btn-lili form-button  mb-3'
          type='submit'
        >
          <FormattedMessage id='common.send'></FormattedMessage>
        </button>
      </Modal.Footer>
    </Modal>
  );
}
